import appActions from './app_actions';
import authActions from './auth_actions';
import scheduleActions from './schedule_actions';
import teacherActions from './teacher_actions';
import cohortActions from './cohort_actions';
import participantActions from './participant_actions';
import meetingActions from './meeting_actions';
import scheduleViewerActions from './schedule_viewer_actions';
import scheduleControlsActions from './schedule_controls_actions';
import meetingLayerActions from './meeting_layer_actions';
import meetingLabelActions from './meeting_label_actions';
import studentCohortActions from './student_cohort_actions';
import modalActions from './modal_actions';

export default Object.assign(
  {},
  appActions,
  authActions,
  scheduleActions,
  teacherActions,
  cohortActions,
  participantActions,
  meetingActions,
  scheduleViewerActions,
  scheduleControlsActions,
  meetingLayerActions,
  meetingLabelActions,
  studentCohortActions,
  modalActions
);


/** WEBPACK FOOTER **
 ** ./src/js/actions/index.js
 **/